import React from "react";
import { Select } from "antd";
import { toDay } from "../../helpers/dayjsHelper";

export const SelectDateGeneral = ({ placeholder = "", style = { width: "30%" }, handleChange = () => {}, selectDateYear = [] }) => {
	return (
		<Select style={style} placeholder={placeholder} defaultValue={toDay().dayFormatYear} onChange={handleChange}>
			{selectDateYear.map((date, index) => {
				return (
					<Select.Option key={`dates-year-${index}`} value={date}>
						{date}
					</Select.Option>
				);
			})}
		</Select>
	);
};
